import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../store'
import { IModalBase, initialDataList } from '@interfaces/common/common.Interface'

export interface NotificationState {
  notificationList?: any
  notificationChiTiet?: any
  modalNotification?: IModalBase
}

const initialState: NotificationState = {
  notificationList: initialDataList,
  notificationChiTiet: {},
  modalNotification: {
    visible: false,
    record: {}
  }
}

export const notificationDucks = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    getListNotification: (state: RootState, action: PayloadAction<any>) => {
      state.notificationList = { loading: true, queryStr: action.payload }
    },
    getListNotificationSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.notificationList = { loading: false, ...action.payload }
    },
    getListNotificationFail: (state: RootState, action: PayloadAction<any>) => {
      state.notificationList = { loading: false, ...action.payload }
    },

    getDetailNotification: (state: RootState, action: PayloadAction<any>) => {
      state.notificationChiTiet = { loading: true, id: action.payload }
    },
    getDetailNotificationSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.notificationChiTiet = { loading: false, ...action.payload }
    },
    getDetailNotificationFail: (state: RootState, action: PayloadAction<any>) => {
      state.notificationChiTiet = { loading: false, ...action.payload }
    },

    setReloadNotificationList: (state: RootState) => {
      state.reloadNotificationList = String(Date.now())
    },
    setModalNotification: (state: RootState, action: PayloadAction<IModalBase>) => {
      state.modalNotification = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  getListNotification,
  getListNotificationSuccess,
  getListNotificationFail,

  getDetailNotification,
  getDetailNotificationSuccess,
  getDetailNotificationFail,

  setReloadNotificationList,
  setModalNotification
} = notificationDucks.actions

export default notificationDucks.reducer

